import React from "react";
import { navigate } from "@reach/router";

import ProjectNavigator from "./projectNavigator";

class ProjectNavigatorContainer extends React.Component {
  constructor(props) {
    super(props);

    this.onClickHandler = this.onClickHandler.bind(this);
  }
  onClickHandler() {
    this.props.handleRouteLoad(false, () => {
      window.setTimeout(() => {
        navigate(`/${this.props.project.fields.slug}`);
      }, 310);
    });
  }

  generateClassName(className, direction) {
    return `${className} ${direction}`;
  }

  render() {
    return (
      <ProjectNavigator
        project={this.props.project}
        className={this.generateClassName(
          "projectNavigator",
          this.props.direction
        )}
        onClickHandler={this.onClickHandler}
      />
    );
  }
}
export default ProjectNavigatorContainer;
